export default __webpack_public_path__ + "static/ux.banana-b35f6527b5a4f85e4fe6e6394754051e.webp";